/// <amd-module name="Search/Wiki/Flux/Sources/TelemetrySpy" />

import * as BaseActionsHub from "Search/Shared/Base/ActionsHub2";
import { ActionsHub } from "Search/Wiki/Flux/ActionsHub";
import { StoresHub } from "Search/Wiki/Flux/StoresHub";
import { TelemetryWriter } from "Search/Wiki/Flux/Sources/TelemetryWriter";
import { CustomerIntelligenceConstants } from "Search/Wiki/Constants";
import { WikiSearchRequest, WikiSearchResponse, WikiResult } from "Search/WebApi/Contracts/Search.Shared";

/**
 * Writes telemetry events based on actions in wiki search page.
 */
export class TelemetrySpy {
    constructor(
        private telemetryWriter: TelemetryWriter,
        private actionsHub: ActionsHub,
        storesHub: StoresHub) {
        this.registerActionsHubHandlers();
    }

    public dispose(): void {
        this.disposeActionsHubHandlers();
        this.telemetryWriter.dispose();
    }

    private registerActionsHubHandlers(): void {
        this.actionsHub.searchStarted.addListener(this.publishSearchStarted);
        this.actionsHub.pageInitializationStarted.addListener(this.publishSearchStarted);
        this.actionsHub.resultsLoaded.addListener(this.publishResultsLoaded);
        this.actionsHub.searchFailed.addListener(this.publishSearchFailed);
    }

    private disposeActionsHubHandlers(): void {
        this.actionsHub.searchStarted.removeListener(this.publishSearchStarted);
        this.actionsHub.pageInitializationStarted.removeListener(this.publishSearchStarted);
        this.actionsHub.resultsLoaded.removeListener(this.publishResultsLoaded);
        this.actionsHub.searchFailed.removeListener(this.publishSearchFailed);
    }

    private publishSearchStarted = (): void => {
        this.telemetryWriter.notifySearchStarted();
        this.telemetryWriter.publish(CustomerIntelligenceConstants.SearchStarted, {});
    }

    private publishResultsLoaded = (payload: BaseActionsHub.IResultsLoadedPayload<WikiSearchRequest, WikiSearchResponse, WikiResult>): void => {
        this.telemetryWriter.publish(CustomerIntelligenceConstants.ResultsLoaded, {
            totalCount: payload.response.count
        });
    }

    private publishSearchFailed = (): void => {
        this.telemetryWriter.dispose();
    }
}
